/**
 * @generated SignedSource<<430b2acdf26caa3eb59bfb6d354eea0d>>
 * @relayHash 01d3cc20dc89cc4f71cd5667af6cdadb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 75dc707963ac426371ab9ef03162af1f51d9bd61c5d5e9deb993cedc848c247d

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type useCreateInvitationUrlMutation$variables = {
  resourceAri: string;
};
export type useCreateInvitationUrlMutation$data = {
  readonly admin_createAccessUrl: {
    readonly __typename: "AdminAccessUrlCreationResponsePayload";
    readonly accessUrl: {
      readonly __typename: "AdminAccessUrlV2";
      readonly id: string;
      readonly url: string;
    } | null | undefined;
  } | null | undefined;
};
export type useCreateInvitationUrlMutation = {
  response: useCreateInvitationUrlMutation$data;
  variables: useCreateInvitationUrlMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "resourceAri"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "resourceAri",
        "variableName": "resourceAri"
      }
    ],
    "concreteType": "AdminAccessUrlCreationResponsePayload",
    "kind": "LinkedField",
    "name": "admin_createAccessUrl",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "concreteType": "AdminAccessUrlV2",
        "kind": "LinkedField",
        "name": "accessUrl",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "url"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useCreateInvitationUrlMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCreateInvitationUrlMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "01d3cc20dc89cc4f71cd5667af6cdadb",
    "id": "75dc707963ac426371ab9ef03162af1f51d9bd61c5d5e9deb993cedc848c247d",
    "metadata": {},
    "name": "useCreateInvitationUrlMutation",
    "operationKind": "mutation",
    "text": "mutation useCreateInvitationUrlMutation($resourceAri:ID!){admin_createAccessUrl(resourceAri:$resourceAri){__typename,accessUrl{__typename,id,url}}}"
  }
};
})();

(node as any).hash = "6f8e6846d2c3a22ff2d39c54fb28cc9b";

export default node;
